import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Loader2, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AuthLayout, PasswordInput, FieldLabel, FormError } from "@/components/auth/AuthLayout";
import { api, formatApiError } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState(token ? "" : "Missing reset token. Please use the link from your email.");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== confirm) return setError("Passwords do not match");
    setBusy(true); setError("");
    try { await api.post("/auth/reset-password", { token, password: pw }); setDone(true); } catch (err) { setError(formatApiError(err)); } finally { setBusy(false); }
  };

  return (
    <AuthLayout title="Choose a new password" subtitle="Make it memorable — you can reveal it as you type.">
      {done ? (
        <div className="space-y-6" data-testid="reset-success">
          <div className="flex gap-3 p-4 rounded-lg border border-emerald-500/30 bg-emerald-500/5">
            <CheckCircle2 className="w-5 h-5 text-emerald-400" /><p className="text-sm text-slate-300">Password updated. You can sign in now.</p>
          </div>
          <Link to="/login" className="text-sm text-[#FFB800] hover:underline" data-testid="reset-goto-login">Go to sign in</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5" data-testid="reset-form">
          <div><FieldLabel>New password</FieldLabel><PasswordInput required minLength={6} value={pw} onChange={(e) => setPw(e.target.value)} testId="reset-password-input" /></div>
          <div><FieldLabel>Confirm password</FieldLabel><PasswordInput required value={confirm} onChange={(e) => setConfirm(e.target.value)} testId="reset-confirm-input" /></div>
          <FormError error={error} />
          <Button type="submit" disabled={busy || !token} className="w-full h-11 mystic-btn text-[#0B0C10] font-semibold tracking-wide" data-testid="reset-submit-button">
            {busy && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}Update password
          </Button>
        </form>
      )}
    </AuthLayout>
  );
}
